export default function (methods) {
  Object.assign(this, methods)
}